import "./debug"
import "./debug/tracking"
import React from "react"
import { createRoot } from "react-dom/client"
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"
import "./main.css"
import "./common/animations.css"
import { AppWithConfig } from "./App"
import { ErrorBoundary } from "@sentry/react"
import { purgeStagedFiles } from "@oboku/archive-metadata/web"

void purgeStagedFiles()

const rootElm = document.getElementById("root")

if (rootElm) {
  const root = createRoot(rootElm)

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <AppWithConfig />
      </ErrorBoundary>
    </React.StrictMode>,
  )
}
